import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';
import { apiKeyHeader } from '../../../../configs/ApiKeys';

export const fetchClasses = createAsyncThunk(
  "classes/fetchClasses",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice.user.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher' || state.authSlice?.user.roles === 'guest_user'; // Check if it's an individual login

    const response = await api.get(
      `/timetable/classes/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
        headers: apiKeyHeader(),
      }
    );

    return response.data;
  }
);

export const createClass = createAsyncThunk(
  'classes/createClass',
  async (classData) => {
    const response = await api.post(`/timetable/classes`, classData,{
    headers: apiKeyHeader()
  });
    return response.data;
  }
);

export const updateClass = createAsyncThunk(
  'classes/updateClass',
  async ({ id, data }) => {
    const response = await api.put(`/timetable/classes/${id}`, data,{
    headers: apiKeyHeader()
  });
    return response.data;
  }
);


export const deleteClass = createAsyncThunk(
  'classes/deleteClass',
  async (id) => {
    await api.delete(`/timetable/classes/${id}`,{
    headers: apiKeyHeader()
  });
    return id;
  }
);

export const activateClassesWithSubjectsAndSections=createAsyncThunk(
  'classes/sectionseubjectLink',
  async(body)=>
  {
    const response= await api.post(`/timetable/classes/linksections`,body,{
    headers: apiKeyHeader()
  });
    return response.data;
  }
)

export const manageClassStatusThunk = createAsyncThunk(
  'classes/manageClassStatus',
  async ({ classId, status }) => {
    const response = await api.put(`/timetable/classes/status/${classId}`, { status },{
    headers: apiKeyHeader()
  });
    return response.data;
  }
);

const classSlice = createSlice({
  name: 'classes',
  initialState: {
    classes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClasses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClasses.fulfilled, (state, action) => {
        state.loading = false;
        state.classes = action.payload;
      })
      .addCase(fetchClasses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createClass.fulfilled, (state, action) => {
        state.classes.push(action.payload);
      })
      .addCase(updateClass.fulfilled, (state, action) => {
        const index = state.classes.findIndex(cls => cls.class_id === action.payload.class_id);
        if (index !== -1) {
          state.classes[index] = action.payload;
        }
      })
      .addCase(deleteClass.fulfilled, (state, action) => {
        state.classes = state.classes.filter(cls => cls.class_id !== action.payload);
      })

       .addCase(activateClassesWithSubjectsAndSections.pending, (state) => {
        state.loading = true;
      })
      .addCase(activateClassesWithSubjectsAndSections.fulfilled, (state, action) => {
        state.loading = false;
        // state.classes = action.payload;
      })
      .addCase(activateClassesWithSubjectsAndSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
       .addCase(manageClassStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageClassStatusThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(manageClassStatusThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
  },
});

export default classSlice.reducer;
